import React from 'react';

export default function Overview() {
  return (
    <section id="overview" className="section bg-dark">
      <div className="max-w-content mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left */}
          <div className="reveal-l">
            <span className="label label-red">Who We Are</span>
            <h2 className="heading mt-5">
              Bridging Brands<br />& <em>Education</em>
            </h2>
            <div className="divider wide mt-5 mb-6" />
            <p className="subtext leading-relaxed mb-4 text-base">
              Chalk and Charter bridges the gap between brands and educational institutions,
              delivering innovative BTL marketing solutions that resonate with student audiences.
            </p>
            <p className="text-white/38 text-sm leading-relaxed">
              We transform campuses into dynamic marketing platforms, creating authentic connections
              that drive engagement and build lasting brand loyalty among tomorrow's consumers.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-4">
              {[
                { title:'Authentic',   desc:'Real engagement'         },
                { title:'Strategic',   desc:'Data-led planning'       },
                { title:'Measurable',  desc:'Outcomes you can report' },
              ].map((p, i) => (
                <div key={p.title} className="card p-4 text-center"
                  style={{ borderColor: i % 2 === 0 ? 'rgba(255,0,50,.15)' : 'rgba(5,131,242,.15)' }}>
                  <div className="text-white font-bold text-sm mb-1">{p.title}</div>
                  <div className="text-white/38 text-xs">{p.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="reveal-r">
            {/* Quote callout */}
            <div className="card p-8 mb-5 relative overflow-hidden"
              style={{ background:'#1c0a0a', borderColor:'rgba(255,0,50,.2)' }}>
              <div className="absolute top-4 right-5 text-7xl font-black text-red-900/20 leading-none select-none"
                style={{ fontFamily:'Georgia,serif' }}>"</div>
              <p className="text-white/80 text-base leading-relaxed italic relative z-10">
                Students are tomorrow's consumers — the campus is the most honest
                place to reach them.
              </p>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-8 h-[2px]" style={{ background:'var(--red)' }} />
                <span className="text-white/40 text-xs font-semibold tracking-wider uppercase">Chalk & Charter</span>
              </div>
            </div>

            {/* 2×2 grid */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { val:'50+',  label:'Campus Partners',   color:'var(--red)'  },
                { val:'200+', label:'Activations Run',   color:'var(--blue)' },
                { val:'100+', label:'Brand Clients',     color:'var(--red)'  },
                { val:'95%',  label:'Satisfaction Rate', color:'var(--blue)' },
              ].map((s, i) => (
                <div key={s.label} className={`card p-5 ${i % 2 === 0 ? 'red-hover' : 'blue-hover'}`}>
                  <div className="font-black text-2xl" style={{ fontFamily:'Playfair Display,serif', color: s.color }}>{s.val}</div>
                  <div className="text-white/45 text-xs mt-1 font-medium">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
